module.exports = __webpack_public_path__ + "img/ums-admin.1c6edd2f.svg";